// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  registerUrlMx: "https://portalopenpay.openpay.mx/register?utm_source=tienda_nube&utm_medium=portal_openpay",
  registerUrlCo: "https://sandbox-dashboard.openpay.co/merchant/production?lang=es_CO&referencedType=TIENDA_NUBE_COL",
  registerUrlAr: "https://sandbox-dashboard.openpayargentina.com.ar/login/register",
  openpayLambdaUrl: "https://sandbox-nuvemshop.openpay.mx",
  openpayComisionesMx: "https://www.openpay.mx/comisiones/",
  secret_key:"mCK5MPzDQg+3y2oYJFWB8Q=="
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
